"use strict";
exports.__esModule = true;
exports.COLOR = exports.TYPE = exports.ALIGN = exports.TYPOGRAPHY = void 0;
exports.TYPOGRAPHY = {
    xxs: 'text-m-xxs sm:text-t-xxs md:text-d-xxs leading-m-xxs sm:leading-t-xxs md:leading-d-xxs',
    xs: 'text-m-xs sm:text-t-xs md:text-d-xs leading-m-xs sm:leading-t-xs md:leading-d-xs',
    sm: 'text-m-sm sm:text-t-sm md:text-d-sm leading-m-sm sm:leading-t-sm md:leading-d-sm',
    base: 'text-m-base sm:text-t-base md:text-d-base leading-m-base sm:leading-t-base md:leading-d-base',
    lg: 'text-m-lg sm:text-t-lg md:text-d-lg leading-m-lg sm:leading-t-lg md:leading-d-lg',
    xl: 'text-m-xl sm:text-t-xl md:text-d-xl leading-m-xl sm:leading-t-xl md:leading-d-xl',
    xxl: 'text-m-xxl sm:text-t-xxl md:text-d-xxl leading-m-xxl sm:leading-t-xxl md:leading-d-xxl',
    '3xl': 'text-m-3xl sm:text-t-3xl md:text-d-3xl leading-m-3xl sm:leading-t-3xl md:leading-d-3xl',
    '4xl': 'text-m-4xl sm:text-t-4xl md:text-d-4xl leading-m-4xl sm:leading-t-4xl md:leading-d-4xl',
    '5xl': 'text-m-5xl sm:text-t-5xl md:text-d-5xl leading-m-5xl sm:leading-t-5xl md:leading-d-5xl',
    'inherit': 'text-inherit leading-inherit'
};
exports.ALIGN = {
    start: 'text-start',
    end: 'text-end',
    right: 'text-right',
    left: 'text-left',
    center: 'text-center',
    justify: 'text-justify',
    inherit: 'text-right'
};
exports.TYPE = {
    light: 'font-family-light',
    regular: 'font-family-regular',
    medium: 'font-family-medium',
    bold: 'font-family-bold'
};
exports.COLOR = {
    inherit: 'text-inherit',
    primary: 'text-primary',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
    control: 'text-control',
    success: 'text-success',
    info: 'text-info',
    warning: 'text-warning',
    danger: 'text-danger',
    black: 'text-black',
    white: 'text-white',
    "grey.100": "text-grey-100",
    "grey.200": "text-grey-200",
    "grey.300": "text-grey-300",
    "grey.400": "text-grey-400",
    "grey.500": "text-grey-500",
    "grey.600": "text-grey-600",
    "grey.700": "text-grey-700",
    "grey.800": "text-grey-800",
    "grey.900": "text-grey-900",
    purple: 'text-purple-500',
    slate: 'text-slate-500',
    gray: 'text-gray-500',
    zinc: 'text-zinc-500',
    neutral: 'text-neutral-500',
    stone: 'text-stone-500',
    red: 'text-red-500',
    orange: 'text-orange-500',
    amber: 'text-amber-500',
    yellow: 'text-yellow-500',
    lime: 'text-lime-500',
    green: 'text-green-500',
    emerald: 'text-emerald-500',
    teal: 'text-teal-500',
    cyan: 'text-cyan-500',
    sky: 'text-sky-500',
    blue: 'text-blue-500',
    indigo: 'text-indigo-500',
    violet: 'text-violet-500',
    fuchsia: 'text-fuchsia-500',
    pink: 'text-pink-500',
    rose: 'text-rose-500'
};
//# sourceMappingURL=text.style.js.map